import { jsx as _jsx } from "react/jsx-runtime";
import { Modal } from '../Modal';
import { ReverLoading } from '../ReverLoading/ReverLoading';
export const ReverLoadingModal = ({ loading, size = 'small', className, ...props }) => {
    return (_jsx(Modal, { isOpen: loading, onRequestClose: () => null, showBorder: false, children: _jsx(ReverLoading, { size: size, className: className, ...props }) }));
};
export default ReverLoadingModal;
